import { Device } from "callable-data-objects";
import { useDevice } from "Hooks/Endpoints";
import { APIDeviceProps } from "Providers/types";
import React from "react";
import { Menu } from "semantic-ui-react";

const FlowMenu = () => {
  const {
    activeFlow,
    selectFlow,
    routeStarts = [],
  }: APIDeviceProps = useDevice();

  return (
    <Menu pointing stackable>
      <Menu.Item header>Your Flows</Menu.Item>
      {routeStarts.map((device: Device) => (
        <Menu.Item
          key={`flow-item-${device.id}`}
          active={activeFlow && device.id === activeFlow.id}
          onClick={() => selectFlow(device.id)}
        >
          {device.name}
        </Menu.Item>
      ))}
    </Menu>
  );
};

export default FlowMenu;
